import { lazy } from 'react'
import type { RouteConfig } from '~/utils/routing'

const Layout = lazy(() => import('./layout'))

const route: RouteConfig<{ invitationId: string }> = {
	path: ['/om', '/en/about'],
	exact: true,
	component: Layout,
}

export default route
